/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class User
 */
import { Role } from '@/modules/backend/Entities/Role';
import { Company } from '@/modules/backend/Entities/Company';
import { UserName } from '@/modules/backend/Entities/UserName';
import { Account } from '@/modules/backend/Entities/Account';
import { Type } from 'class-transformer';
import { Provider } from '@/modules/backend/Entities/Provider';

export class User {
  private id!: number;
  private email!: string;

  @Type(() => UserName)
  private name!: UserName;

  @Type(() => Role)
  private roles!: Role[];

  @Type(() => Company)
  private companies!: Company[];

  @Type(() => Provider)
  private providers!: Provider[];

  @Type(() => Account)
  private account!: Account;

  public getId(): number {
    return this.id;
  }

  public getEmail(): string {
    return this.email;
  }

  public getCompanies(): Company[] {
    return this.companies;
  }

  public getRoles(): Role[] {
    return this.roles;
  }

  public getName(): UserName {
    return this.name;
  }

  public getAccount(): Account {
    return this.account;
  }

  public getProviders(): Provider[] {
    return this.providers || [];
  }

  public isAdmin(): boolean {
    return this.roles.some((role: Role) => role.getName() === 'admin');
  }
}
